import html2pdf from "html2pdf.js";

// Export a DOM element to a downloadable A4 PDF.
// opts: { pageNumbers?: boolean, headerText?: string }
export function exportElementToPdf(element, filename = "documento.pdf", opts = {}) {
  const { pageNumbers = false, headerText = "" } = opts;
  const worker = html2pdf()
    .set({
      margin: 0,
      filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    })
    .from(element);

  if (!pageNumbers && !headerText) {
    return worker.save();
  }

  return worker
    .toPdf()
    .get("pdf")
    .then((pdf) => {
      const total = pdf.internal.getNumberOfPages();
      const w = pdf.internal.pageSize.getWidth();
      const h = pdf.internal.pageSize.getHeight();
      for (let i = 1; i <= total; i++) {
        pdf.setPage(i);
        pdf.setFontSize(8);
        pdf.setTextColor(150, 150, 150);
        if (headerText && i > 1) {
          pdf.text(headerText, 12, 8);
        }
        if (pageNumbers) {
          pdf.text(`Pag. ${i} / ${total}`, w - 28, h - 7);
        }
      }
    })
    .save();
}
